import './index.less';
import Service from './service';

const { Feature, meta, hook, event } = checkApp.core; //eslint-disable-line
const { Button, Tooltip, Loading } = checkApp.components;//eslint-disable-line

@meta('cart', ['request'], -9)
export default class CartFeature extends Feature {

  @event('cart.inject')
  createService() {
    this.service = new Service(this.request);
  }

  renderList(list, loading) {
    if (list.length < 1) return this.renderEmpty(loading);
    return <ul className="product-list">
      {list.map(item => (
        <li className="product-item" key={item.name}>
          <Tooltip
            trigger={<span className="name">{item.name || 'unknow'}</span>}>
            {item.name || 'unknow'}
          </Tooltip>
          <Button className="aps-pull-right"
            onClick={() => this.remove(item)}
            type="primary"
            size="small">
            移除
          </Button>
        </li>
      ))}
    </ul>;
  }

  /**
   * 渲染列表长度为 0 时的信息
   * @param {boolean} loading 是否为 Loading 状态
   * @returns {object} dom
   */
  renderEmpty(loading) {
    return <div className="empty">
      {loading ? '正在载入...' : '您还没有添加任何域名'}
    </div>;
  }

  /**
   * 渲染右侧面板
   * @param {object} state 状态对象
   * @returns {objecg} 面板 dom
   */
  @hook('main.renderSidePanel')
  renderSidePanel() {
    const { loading, list = [] } = this.getState({ scoped: true });
    return <div key={this.id} className="panel side cart-panel">
      <div className="panel-heading">
        <span className="title">域名清单</span>
        <span className="badge">{list.length}</span>
        <a className="aps-pull-right clear"
          onClick={this.clear}>清空清单</a>
      </div>
      {this.renderList(list, loading)}
      {this.renderFooter()}
    </div>;
  }

  renderFooter() {
    const list = this.getCurrentList();
    if (list.length < 1) return;
    return <div className="panel-footer aps-right">
      <Button shape="warning"
        onClick={() => {
          location.href = '//netcn.console.aliyun.com/core/buy/commonbuy';
        }}
        size="small">立即结算</Button>
    </div>;
  }

  getCurrentList() {
    let { list = [] } = this.getState({ scoped: true });
    return list.slice(0);
  }

  @event('ready')
  async fetch(opts) {
    const list = await this.service.getList(opts);
    this.setState({ list }, { scoped: true });
  }

  async has(info) {
    //console.log('has', info);
    let list = this.getCurrentList();
    if (!list) {
      list = await this.service.getList();
      this.setState({ list }, { scoped: true });
    }
    info.value = info.value || info.domain;
    return list.some(item => item.value == info.value);
  }

  async remove(info, opts = {}) {
    //console.log('remove', info);
    if (!(await this.has(info))) return;
    const item = {
      value: info.domain || info.value,
      type: info.type || 'domain',
      period: info.period || 12
    };
    await this.service.remove(item, opts);
    if (opts.fetch !== false) await this.fetch();
    if (opts.event !== false) {
      this.emit('remove', [item.value], [item]);
      this.emit('change', [item.value]);
    }
  }

  async add(info, opts = {}) {
    //console.log('add', info);
    if (await this.has(info)) return;
    const item = {
      name: info.name || info.domain,
      value: info.value || info.domain,
      type: info.type || 'domain',
      period: info.period || 12,
      domain: info.domain
    };
    await this.service.add(item, opts);
    if (opts.fetch !== false) await this.fetch();
    if (opts.event !== false) {
      this.emit('add', [item.value], [item]);
      this.emit('change', [item.value], [item]);
    }
  }

  clear = async () => {
    const loading = await Loading.show();
    const list = this.getCurrentList();
    await Promise.all(list.map(item => this.remove(item, {
      event: false, fetch: false, loading: false
    })));
    await this.fetch();
    this.emit('change', list.map(item => item.value), list);
    loading.close();
  }

}


// WEBPACK FOOTER //
// ./src/cart/index.js